export function parsePastedValue(cellValue: string): number | null {
  cellValue = cellValue.replace(/[\u00a0\u202f]/g, "").trim();
  if (cellValue === "") return null;
  let value = Number(cellValue);
  if (isNaN(value)) {
    if (cellValue.includes(",") && !cellValue.includes(".")) {
      value = Number(cellValue.replace(",", "."));
    } else if (cellValue.includes(",") && cellValue.includes(".")) {
      const firstCommaIndex = cellValue.indexOf(",");
      const firstDotIndex = cellValue.indexOf(".");
      if (firstDotIndex < firstCommaIndex) {
        value = Number(cellValue.replace(".", "").replace(",", "."));
      } else {
        value = Number(cellValue.replace(/,/g, ""));
      }
    }
  }
  return Number.isFinite(value) ? value : null;
}
